<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Select a Firearm from the list"
          [matTooltipDisabled]="disabledTooltip(this.firearm)">
          <mat-label i18n="@@type.FirearmAssignmentLog.firearm">Firearm</mat-label>
          <mat-select formControlName="firearm" id="firearm" (ngModelChange)="firearmChanging($event)"
            [(ngModel)]="item.firearm" (ngModelChange)="firearmChanged($event)" #firearm placeholder="Firearm"
            [compareWith]="firearmCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let firearm of firearmSelectionList" [value]="firearm">
              {{firearmDisplay(firearm)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Lifecycle State" [matTooltipDisabled]="disabledTooltip(this.lifecycleState)">
          <mat-label i18n="@@type.FirearmAssignmentLog.lifecycleState">Lifecycle State</mat-label>
          <input matInput formControlName="lifecycleState" id="lifecycleState"              
              [value]="item.lifecycleState | refDecode:'FIREARM_LIFECYCLE_STATE' | async" #lifecycleState              
              placeholder="Lifecycle State" disabled>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="currentlyAssignable"
            id="currentlyAssignable" [ngModel]="item.currentlyAssignable" #currentlyAssignable [disabled]="true"
            disabled i18n="@@type.FirearmAssignmentLog.currentlyAssignable">
            Currently Assignable </mat-slide-toggle>
        </span>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <app-firearm-assignment-list [items]="item.assignments"></app-firearm-assignment-list>
    </div>
  </form>
</div>